import Preact from 'preact';
import * as Hooks from 'preact/hooks';
import { ParagraphWithHeadingAndIcon } from '@dora/components';
import { Box } from '@mui/material';
import { AlertHexagon } from '@dora/components/src/icons/alertHexagon';
import { useTheme } from '@mui/material/styles';

export function Component(props: { heading: string; paragraph: string }) {
    const theme = useTheme();

    return (
        <Box
            bgcolor="#EEF2FF"
            position="absolute"
            width="100%"
            height="100%"
            top="0px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            zIndex={theme.zIndex.modal + 1} // needs to show above the changes alert
        >
            <ParagraphWithHeadingAndIcon.Component
                heading={props.heading}
                paragraph={props.paragraph}
                Icon={AlertHexagon}
            />
        </Box>
    );
}
